import * as React from 'react';

import { Container} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import BackButton from '../components/BackButton.jsx';
import DishCardM from '../components/DishCardM.jsx';

import * as ApiCall from '../ApiCall.jsx';

//just for testing the components
import chipsJPG from '../chips1.jpg';
import { useNavigate, useLocation } from 'react-router-dom';

function CategoryM() {

  //TODO:   
  //api call to get a list of dishes and their details

  //assume order of dishes given is display order
  
  //for each dish create a dish card
  //return all the cards in order for display

  //while waiting for api calls, should display loading spinner

  const [state, setState] = React.useState('loading');

  const [test, setTest] = React.useState(
    {
        thumbnail: chipsJPG,
        name: "Chips",
        category: "Starters",
        description: "Chips are chips",
        price: 100,
      }
  )

//   const { statee } = useLocation();
//   if (statee) {
//     const { dishInfo } = statee;
//     setTest(dishInfo);
//   }

  //test apicall
  //set state to loading while apiCalling
  React.useEffect(() => {
    // ApiCall.get('/menu/dish/', "dishname=Bat soup&desciption=Tasty")
    //   .then(({dish}) => {

    //     setTest({
    //       thumbnail: chipsJPG,
    //       name: dish.name,
    //       category: "Starters",
    //       description: dish.description,
    //       price: dish.price,
    //     });
    //     console.log(test);
    //     setState('success')
    //   })
    //   .catch((msg) => {alert(msg)});
    setState('success')
  }, []);

  const dishes = [1, 2, 3, 4, 5];

  return (
    <>
      <BackButton />
      {state === 'loading'
        ? ( 
            <>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
              </Box>               
            </>
          )
        : (
            <>
              <Container sx={{display: 'flex', justifyContent: 'center',  flexDirection: 'column', flexWrap: 'wrap'}}>
                {
                  dishes.map((dish) => (
                    <DishCardM dishInfo={test} ></DishCardM>
                    //need to input the dish structs instead of just the test guy
                  ))
                }
              </Container>
            </>
          )}
      </>
  );
}

export default CategoryM;